<template>
	  <Cascader :data="categoryData" trigger="hover" placeholder="类别"></Cascader>
</template>
<script type="text/javascript">
import category from '../../../assets/json/foreigntrede.json'
	export default{
		name:"ForeignTradeCategory",
		data (){
			return{
				categoryData:category
			}
		}
	}
</script>
<style>
	
</style>